import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Controller } from "react-hook-form";
import { normalizeHomoglyphs } from "../../filters/seachFilter";

const defaultFilterOptions = (options, inputValue) => {
  if (!inputValue.trim()) return options;

  const normalizedSearch = normalizeHomoglyphs(inputValue.trim());
  const words = normalizedSearch.split(/\s+/).filter(Boolean);

  return options.filter(option => {
    const searchableText = normalizeHomoglyphs(
      `${option.title || ''}`
    );

    return words.every(word => searchableText.includes(word));
  });
};

const ComboBox = (props) => {
  const {
    name,
    control,
    label,
    options,
    variant,
    margin,
    emptyMessage,
    required,
    errors,
    loading,
    disableClearable,
    defaultValue,
    disabled,
    onChange,
    freeSolo,
    valueAsString,
    filterOptions, // <-- новый пропс
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue ?? null}
      render={({ field }) => (
        <Autocomplete
          {...field}
          options={options}
          freeSolo={freeSolo}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option?.title || ""
          }
          getOptionSelected={(option, value) =>
            typeof value === "string"
              ? option.title === value
              : option.id === value?.id
          }
          openText="Открыть"
          closeText="Закрыть"
          clearText="Очистить"
          noOptionsText={emptyMessage || "Нет данных"}
          loading={loading}
          loadingText="Загрузка..."
          fullWidth
          disableClearable={disableClearable}
          disabled={disabled}
          // Применяем кастомную фильтрацию, если она передана
          filterOptions={(optionsList, params) =>
            (filterOptions || defaultFilterOptions)(optionsList, params.inputValue)
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              variant={variant || "outlined"}
              margin={margin || "dense"}
              required={required || false}
              error={!!errors}
              helperText={errors?.message}
              placeholder="Выберите из списка"
              InputLabelProps={{ shrink: true }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
          onChange={(_, data) => {
            const formValue = valueAsString
              ? (typeof data === "string" ? data : data?.title || "")
              : data;
            field.onChange(formValue);
            if (onChange) onChange(_, formValue);
          }}
          onInputChange={(_, value, reason) => {
            if (valueAsString && (reason === "input" || reason === "clear")) {
              field.onChange(value);
            }
          }}
        />
      )}
    />
  );
};

export default React.memo(ComboBox);
